import React from 'react'
import { useState, useEffect } from 'react';
import { make_readable_date } from '../../js functions/chartCompute.js';
import { get_data_of_exercise } from '../../js functions/LDBfunctions';
import Counter from './master/counter.js';
import Line_chart from './master/Line_chart.js';

function PersonalRecord({ dateRangeStart, dateRangeEnd, ActiveExcercise, }) {

    const [PersonalRecordData, setPersonalRecordData] = useState([]);
    const [slope, setSlope] = useState(0);
    const heading = "New Personal Record";
    const Yaxis_name = "Weight (kg)";


    useEffect(() => {

        compute_oneRepMax(dateRangeStart, dateRangeEnd, ActiveExcercise);

    }, [dateRangeStart, dateRangeEnd, ActiveExcercise]);




    async function compute_oneRepMax(dateRangeStart, dateRangeEnd, ActiveExcercise) {

        try {

            const data = await get_data_of_exercise(dateRangeStart, dateRangeEnd, ActiveExcercise); // array between from and to dates of specific exercise

            if (!data || data.length === 0) {


                console.log('ONE REP : No data available for the selected exercise and date range');
                setPersonalRecordData([]);

            } else {


                const chartData = [];

                data.forEach((record) => {
                    let heaviest_weight = 0.0; // Use let since the value is updated

                    const sets = record.sets;

                    sets.forEach((set) => {
                        if (set.weight_kg > heaviest_weight) {
                            heaviest_weight = set.weight_kg;
                        }
                    });

                    chartData.push({
                        y: heaviest_weight,
                        x: make_readable_date(record.start_time),
                    });
                });

                // console.log('chartData: ', chartData);

                setPersonalRecordData(chartData);


            }



        } catch (error) {
            console.log(error);
        }


        let data = [];






    }





    return (
        <div className='chart-card-container'>
            <h4>{heading}</h4>

            <div className="chart-card">


                <div className='summary-box' >



                    <div className='counter-box' >

                        <Counter counterData={slope} heading={"Slope"} />

                        <Counter />

                    </div>


                    <p> Great job! Your total volume for incline dumbbell press has increased by 15% over the last month. This shows your chest and upper body strength are improving steadily. Keep it up!  </p>
                </div>



                <Line_chart data={PersonalRecordData} Yaxis_name={Yaxis_name} />



            </div>


        </div>
    )
}

export default PersonalRecord